import Vue from 'vue';
import Component from 'vue-class-component';
import Form from '@/components/form/form';
import EdFormModel from '@/models/ed-form.model';
import EdInputModel from '@/models/ed-input.model';
import { required, maxLength, minLength } from 'vuelidate/lib/validators'
import KEYS from '@/values/keys';
import { Status } from '@/models/status.model';
import { CORE_ROUTES } from '@/core/core.router'
import EdPasswordProgressBar from '@/auth/components/ed-password-progress-bar/ed-password-progress-bar.vue'
import { Prop } from 'vue-property-decorator';

@Component({
  name: 'ed-reset-password',
  components: {
    ...Form,
    EdPasswordProgressBar
  },
})
export default class EdResetPasswordComponent extends Vue {
  @Prop({ default: true }) hasTitle: boolean;

  public form: any = [];
  public successReset: boolean = false;
  public differentPass: boolean = false;
  public inputMode: string = KEYS.INPUT_MODES.LINE;
  public timeOut: any;
  public status: Status = new Status();
  public isStrong: boolean = false;
  public changePassMode: boolean = true;
  public username: string = '';
  public successChange: boolean = false;
  public oldPassIncorrect: boolean = false;
  public genericError: boolean = false;
  public oldAndNewEqual: boolean = false;

  public created() {
    if (!this.$route.params.verificationId) {
      this.username = this.$store.state.AuthStore.user.email;
      this.changePassMode = true;
      this.form = EdFormModel([
        EdInputModel('oldPassword', '', { required, maxLength: maxLength(30) }),
        EdInputModel('newPassword1', '', { required, maxLength: maxLength(30) }),
        EdInputModel('newPassword2', '', { required, maxLength: maxLength(30) })
      ]);
    }
    else {
      this.username = this.$route.params.username;
      this.changePassMode = false;
      this.form = EdFormModel([
        EdInputModel('newPassword1', '', { required, maxLength: maxLength(30) }),
        EdInputModel('newPassword2', '', { required, maxLength: maxLength(30) })
      ]);
    }
  }

  public goHome() {
    this.$router.push({ name: CORE_ROUTES.PUBLIC.HOME.NAME })
  }

  public verifyOldAndNewEqual() {
    if (this.form.oldPassword.value == '' || this.form.newPassword1.value == '')
      return false;
    else if (this.form.oldPassword.value == this.form.newPassword1.value)
      return true;
    else
      return false;
  }

  public verifyOldPass() {
    this.oldPassIncorrect = false;
    this.oldAndNewEqual = this.verifyOldAndNewEqual();
  }

  public verifyPasswords() {
    if (this.changePassMode)
      this.oldAndNewEqual = this.verifyOldAndNewEqual();

    this.differentPass = false;
    if (this.form.newPassword1.value == '' || this.form.newPassword2.value == '')
      this.differentPass = false;
    else if (this.form.newPassword1.value != this.form.newPassword2.value) {
      this.differentPass = true;
    }
  }

  public async resetPassword() {
    let verificationId = this.$route.params.verificationId;
    let password = this.form.newPassword1.value;
    try {
      await this.$Auth.Services.resetPassword(password, this.username, verificationId)
      this.successReset = true;
      setTimeout(() => {
        this.$router.push({ name: CORE_ROUTES.PUBLIC.HOME.NAME });
      }, 3500);
    } catch (e) {
      this.status.setError();
    }
  }

  public async changePassword() {
    this.genericError = false;
    let oldPassword = this.form.oldPassword.value;
    let newPassword = this.form.newPassword1.value;
    try {
      await this.$Auth.Services.changePassword(oldPassword,newPassword,this.username)
      this.successChange = true;
      this.form.set('oldPassword', '');
      this.form.set('newPassword1', '');
      this.form.set('newPassword2', '');
    } catch (e) {
      this.genericError = true;
      this.status.setError();
    }
  }

  public isChangePassDisabled() {
    if (!this.isStrong || (this.form.newPassword1.value != this.form.newPassword2.value) || !this.form.valid || this.verifyOldAndNewEqual())
      return true;
    else
      return false;
  }

  public watchIfStrong(isStrong: boolean) {
    this.isStrong = isStrong;
  }
}